module.exports = __webpack_public_path__ + "img/bank_transfer.d180e97f.svg";